var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "info_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#info_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "M8 11.332a.645.645 0 0 0 .475-.192.645.645 0 0 0 .191-.475V8a.645.645 0 0 0-.191-.475A.645.645 0 0 0 8 7.332a.645.645 0 0 0-.475.192.645.645 0 0 0-.192.475v2.666c0 .19.064.348.192.475a.645.645 0 0 0 .475.192Zm0-5.333a.645.645 0 0 0 .475-.192.645.645 0 0 0 .191-.475.645.645 0 0 0-.191-.475A.645.645 0 0 0 8 4.665a.645.645 0 0 0-.475.192.645.645 0 0 0-.192.475c0 .189.064.347.192.475A.645.645 0 0 0 8 5.999Zm0 8.666a6.492 6.492 0 0 1-2.6-.525 6.732 6.732 0 0 1-2.117-1.425A6.733 6.733 0 0 1 1.858 10.6a6.492 6.492 0 0 1-.525-2.6c0-.923.175-1.79.525-2.6a6.732 6.732 0 0 1 1.425-2.117c.6-.6 1.306-1.075 2.117-1.425A6.492 6.492 0 0 1 8 1.332c.922 0 1.789.175 2.6.525.81.35 1.516.825 2.116 1.425.6.6 1.075 1.306 1.425 2.117.35.81.525 1.677.525 2.6 0 .922-.175 1.789-.525 2.6a6.733 6.733 0 0 1-1.425 2.116c-.6.6-1.305 1.075-2.116 1.425a6.492 6.492 0 0 1-2.6.525Z"
}))));
export default SvgInfo;